var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fuel-funds__distribution" }, [
    _c(
      "ul",
      { staticClass: "fuel-funds__vendor-list" },
      _vm._l(_vm.percentages, function(vendor, index) {
        return _c("FuelFundsVendor", { key: index, attrs: { vendor: vendor } })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }